// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3t6YL","legacyBtn":"MutateMid_legacyBtn__n4JjS"};